<script>
import { ProductionCraftServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
const pdcsp = new ProductionCraftServiceProxy()
const columns = [
  {
    title: 'page_product_process_no',
    dataIndex: 'processCode',
    scopedSlots: { customRender: 'processCode' }
  },
  {
    title: 'page_product_process_name',
    dataIndex: 'processName'
  },
  {
    title: 'page_product_process_sequence',
    dataIndex: 'processSort',
    scopedSlots: { customRender: 'processSort' }
  }
]
export default {
  data() {
    return {
      count: 1,
      processCodeList: [],
      processSequence: {},
      customRow: (record) => {
        return {
          on: {
            click: (e) => {
              this.$emit('customRow', record)
            }
          }
        }
      }
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    selectedId: {
      type: String,
      default: ''
    },
    scrollY: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    filter: {
      type: Object,
      default: () => ({})
    },
    craftId: {
      type: String,
      default: ''
    },
    selectedRowKeys: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleTableChange(value) {
      this.$emit('handleTableChange', value)
    },
    handleAdd() {
      this.getProcessCode()
      this.$emit('handleAdd')
    },
    async getProcessCode() {
      const res = await pdcsp.getProcessForProductionCraft(this.craftId)
      this.processCodeList = res
    },
    onSelectChange(value) {
      this.$emit('onChange', value)
    },
    async handleChange(value, key, column) {
      if (column === 'processCode') {
        const code = this.processCodeList.find((res) => res.id === value)
        if (code) {
          const list = this.processCodeList.filter((res) => res.code === code.code)
          this.processSequence[key] = list
        }
        this.$emit('handleChange', code.code, key, column)
        this.$emit('handleChange', '', key, 'processSequence')
        this.$emit('handleChange', '', key, 'processName')
        this.$emit('handleChange', '', key, 'processSort')
      } else if (column === 'processSort') {
        const code = this.dataSource.find((res) => res.id === key)
        if (code) {
          const square = this.processCodeList.find(
            (res) => res.sort === value && res.code === code.processCode
          )
          this.$emit('handleChange', square.processSequence, key, 'processSequence')
          this.$emit('handleChange', square.name, key, 'processName')
        }
        this.$emit('handleChange', value, key, column)
      }
    }
  }
}
</script>

<template>
  <div class="qcprocess-table">
    <a-button
      v-acl="'page_product_plan_quality_add_process'"
      class="editable-add-btn"
      type="default"
      @click="handleAdd"
      :disabled="craftId === ''"
    >
      {{ $t('page_product_add_process') }}
    </a-button>
    <ml-table
      :columns="columns"
      rowKey="id"
      :selectRowKey="selectedId"
      :data-source="dataSource"
      :customRow="customRow"
      :scroll="{ y: scrollY }"
      :rowSelection="{ selectedRowKeys, onChange: onSelectChange }"
      bordered
    >
      <template slot="processCode" slot-scope="text, record">
        <div>
          <a-select
            :value="text"
            v-if="record.id.indexOf('add') !== -1"
            style="width: 100px"
            @change="(value) => handleChange(value, record.id, 'processCode')"
          >
            <template v-for="(process, index) in processCodeList">
              <a-select-option :value="process.id" :key="index">
                {{ process.code }}
              </a-select-option>
            </template>
          </a-select>
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="processSort" slot-scope="text, record">
        <div>
          <a-select
            :value="text"
            v-if="record.id.indexOf('add') !== -1"
            style="width: 100px"
            @change="(value) => handleChange(value, record.id, 'processSort')"
          >
            <template v-for="(process, index) in processSequence[record.id]">
              <a-select-option :value="process.sort" :key="index">
                {{ process.sort }}
              </a-select-option>
            </template>
          </a-select>
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
    </ml-table>
    <a-pagination
      style="position:absolute;bottom: -4px;right: 0"
      :show-total="(total) => `${showTotal(total)}`"
      :current="filter.current"
      :pageSize="filter.size"
      :total="total"
      @change="handleTableChange"
    />
  </div>
</template>

<style scoped>
.editable-add-btn {
  width: 100%;
  margin-bottom: 4px;
}
.qcprocess-table {
  position: relative;
  height: 100%;
}
</style>
